import React from 'react'
import { observer } from 'mobx-react'
import { DropdownButton, MenuItem } from 'react-bootstrap'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import Filters from '../global_filters'
import ListView from 'bstrap-react-mobx-admin/view/list'
import SelectInput from '../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'

const FilmListView = ({ store }) => {
  if (!store.hasRight(defaultConst.ENTNAMES.FILMS)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const fields = [
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => {
      const DetailLink = ({ text }) => (
        <React.Fragment>
          <a href='javascript:void(0)' onClick={() => store.detailClicked(row)}>{text}</a>
          <a href={`/entity/${store.router.params.entityname}/${row.id}`}
            target="_blank" rel="noreferrer" title={store.__('Open link in new tab')} className="text-muted link-icon">
            <i className="glyphicon glyphicon-new-window" />
          </a>
        </React.Fragment>
      )
      return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
    },
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />)
  ]

  const batchActions = () => {
    return (
      <DropdownButton className={defaultConst.ACTION_BUTTON_CLASS1} title={store.__(defaultConst.TITLE_BATCH_ACTIONS)} pullRight id='listactions-dropdown'>
        <MenuItem key={linkConst.BATCH_ACTION_SETINACTIVE} eventKey={linkConst.BATCH_ACTION_SETINACTIVE}
          onClick={store.gotoBatch.bind(store, linkConst.BATCH_ACTION_SETINACTIVE)}>
          <span className={linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_SETINACTIVE].icon} />&nbsp;
          {store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_SETINACTIVE].title)}
        </MenuItem>
        <MenuItem key={linkConst.BATCH_ACTION_PRICING} eventKey={linkConst.BATCH_ACTION_PRICING}
          onClick={store.gotoBatch.bind(store, linkConst.BATCH_ACTION_PRICING)}>
          <span className={linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_PRICING].icon} />&nbsp;
          {store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_PRICING].title)}
        </MenuItem>
        <MenuItem key={linkConst.BATCH_ACTION_PRICING_TEMP} eventKey={linkConst.BATCH_ACTION_PRICING_TEMP}
          onClick={store.gotoBatch.bind(store, linkConst.BATCH_ACTION_PRICING_TEMP)}>
          <span className={linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_PRICING_TEMP].icon} />&nbsp;
          {store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_PRICING_TEMP].title)}
        </MenuItem>
        <MenuItem key={linkConst.BATCH_ACTION_CATEGORIES} eventKey={linkConst.BATCH_ACTION_CATEGORIES}
          onClick={store.gotoBatch.bind(store, linkConst.BATCH_ACTION_CATEGORIES)}>
          <span className={linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_CATEGORIES].icon} />&nbsp;
          {store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_CATEGORIES].title)}
        </MenuItem>
        <MenuItem key={linkConst.BATCH_ACTION_CONTRACT} eventKey={linkConst.BATCH_ACTION_CONTRACT}
          onClick={store.gotoBatch.bind(store, linkConst.BATCH_ACTION_CONTRACT)}>
          <span className={linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_CONTRACT].icon} />&nbsp;
          {store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_CONTRACT].title)}
        </MenuItem>
        <MenuItem key={linkConst.BATCH_ACTION_SYNCFILMRATINGS} eventKey={linkConst.BATCH_ACTION_SYNCFILMRATINGS}
          onClick={store.gotoBatch.bind(store, linkConst.BATCH_ACTION_SYNCFILMRATINGS)}>
          <span className={linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_SYNCFILMRATINGS].icon} />&nbsp;
          {store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_SYNCFILMRATINGS].title)}
        </MenuItem>
        <MenuItem key={linkConst.BATCH_ACTION_ASSIGN_FOR_TESTING} eventKey={linkConst.BATCH_ACTION_ASSIGN_FOR_TESTING}
          onClick={store.gotoBatch.bind(store, linkConst.BATCH_ACTION_ASSIGN_FOR_TESTING)}>
          <span className={linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_ASSIGN_FOR_TESTING].icon} />&nbsp;
          {store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_ASSIGN_FOR_TESTING].title)}
        </MenuItem>
        <MenuItem divider />
        <MenuItem key={linkConst.BATCH_ACTION_UPLOAD_ARCHIVE} eventKey={linkConst.BATCH_ACTION_UPLOAD_ARCHIVE}
          onClick={store.gotoBatch.bind(store, linkConst.BATCH_ACTION_UPLOAD_ARCHIVE)}>
          <span className={linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_UPLOAD_ARCHIVE].icon} />&nbsp;
          {store.__(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_UPLOAD_ARCHIVE].title)}
        </MenuItem>
        <MenuItem key={'delete'} eventKey={'delete'} onClick={store.batchDelete.bind(store)}>
          <span className='glyphicon glyphicon-remove' />&nbsp;
          {store.__(defaultConst.TITLE_DELETE)}
        </MenuItem>
      </DropdownButton>
    )
  }

  const filters = {
    id_like: {
      title: 'ID',
      component: (props) => (<TextInput {...props} />)
    },
    slug_like: {
      title: 'Slug',
      component: (props) => (<TextInput {...props} />)
    },
    title_like: {
      title: 'Title',
      component: (props) => (<TextInput {...props} />)
    },
    imdb_id_like: {
      title: 'IMDB id',
      component: (props) => (<TextInput {...props} />)
    },
    platforms_like: {
      title: 'Platforms',
      component: (props) => (<TextInput {...props} />)
    },
    video_type: {
      title: 'Type',
      component: (props) => (<SelectInput {...props} optionsrecord={store.options} optionsattr={'video_type'} />)
    }
  }

  const onAddClicked2 = () => {
    return (store.router.goTo(store.views.entity_detail,
      { entityname: store.router.params.entityname, id: '_new' },
      store, { type: 'bundle' })
    )
  }

  return (<ListView
    store={store.cv}
    helper={store.helpFor(linkConst.LINK_FILMS)}
    fields={fields}
    filters={() => Filters(store, filters)}
    onAddClicked={store.addClicked.bind(store)}
    onAddClicked2={onAddClicked2}
    onAddClicked2text={store.__('Bundle')}
    onAddClicked2tip={store.__('Create bundle of few films')}
    batchActions={batchActions} />)
}
export default observer(FilmListView)
